export const MAX_NUM_SELECTED = 50;
